import { captureRequestAuthority } from "./authority";
import type { PartnerImportBatch } from "./models";

// Only validator metadata lives here. The authority-keyed TanStack cache owns the actual DTO;
// dropping its object also drops this weak entry. No second body cache or browser persistence.
const validators = new WeakMap<PartnerImportBatch, { etag: string; authorityRevision: number }>();
export function rememberImportStatusValidator(
  batch: PartnerImportBatch,
  etag: string | null,
): void {
  if (etag && /^"[a-f0-9]{64}"$/u.test(etag))
    validators.set(batch, { etag, authorityRevision: captureRequestAuthority().revision });
  else validators.delete(batch);
}
export function importStatusValidator(
  batch: PartnerImportBatch | undefined,
  batchId: string,
): string | undefined {
  if (!batch || batch.id !== batchId) return undefined;
  const value = validators.get(batch);
  return value?.authorityRevision === captureRequestAuthority().revision ? value.etag : undefined;
}
